import { createAction } from 'redux-act'

import { Thunk } from '../types'
import { SAVE_HISTORY_ITEMS } from './action-types'
import { BaseSearchbarHistoryItem, SearchbarHistoryItem } from './types'
import { getSearchbarHistoryItemsState } from './selectors'

const isSameLocalDay = (a: Date | null, b: Date | null): boolean => {
    if (a === b) {
        return true
    }
    if (!a || !b) {
        return false
    }
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
}

export const saveHistoryItems = createAction<SearchbarHistoryItem[]>(SAVE_HISTORY_ITEMS)

export const saveHistoryItem =
    ({ search, arrival, departure, adults, children }: BaseSearchbarHistoryItem): Thunk =>
    (dispatch, getState) => {
        const historyItems = [...getSearchbarHistoryItemsState(getState())]

        const index = historyItems.findIndex(
            historyItem =>
                historyItem.search === search &&
                isSameLocalDay(historyItem.arrival, arrival) &&
                isSameLocalDay(historyItem.departure, departure) &&
                historyItem.adults === adults &&
                historyItem.children === children,
        )

        const item = {
            search,
            arrival,
            departure,
            adults,
            children,
            _time: Date.now(),
            _count: index === -1 ? 1 : historyItems[index]._count + 1,
        }

        if (index !== -1) {
            historyItems.splice(index, 1)
        }
        historyItems.unshift(item)
        if (historyItems.length > 5) {
            historyItems.pop()
        }

        dispatch(saveHistoryItems(historyItems))
    }
